import { HandCoins } from "@/components/icons";
import { Button } from "@/components/ui/button";
import Typography from "@/components/ui/typography";

interface StripeConnectBannerProps {
  connectUrl: string | null;
}

const StripeConnectBanner = ({ connectUrl }: StripeConnectBannerProps) => {
  return (
    <div className="bg-[#DCDDFA] rounded-2xl p-4 sm:p-6">
      <div className="flex items-start gap-4">
        <HandCoins className="h-5 w-5 text-[#4F55E8] flex-shrink-0 mt-0.5" />
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 flex-1">
          <div className="space-y-0.5">
            <Typography size="l2" className="font-semibold text-[#494949]">
              Connect Stripe
            </Typography>
            <Typography size="b2" className="text-[#767677]">
              Connect your Stripe account to receive payouts.
            </Typography>
          </div>
          <Button
            asChild
            className="bg-[#1e1e24] text-white hover:bg-[#333] whitespace-nowrap self-start sm:self-auto"
          >
            <a
              href={connectUrl || "#"}
              target="_blank"
              rel="noopener noreferrer"
            >
              Connect
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StripeConnectBanner;
